import {
    Box,
    styled,
    tableCellClasses
} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import FormInputPrompt from '../popups/FormInputPrompt';
import OffsetInputField from './OffsetInputField';

export default function ResultOffset({}) {
    const [netEmissions_output, setNetEmissions_output] = useState(null);
    
    return (
        <>
        <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <StyledTableCell component="th" scope="row" bgcolor={'#a5dfb7'} fontcolor={"#555555"}>
                <Box sx={{display:'flex'}}>
                    Carbon Offset &emsp;
                    <FormInputPrompt 
                        id_name={"credit_prompt"} 
                        content={"This calculator lets users enter the amount of carbon offset for the event, which will be deducted from the total to determine the net (unoffset) carbon emissions."} 
                    />
                </Box>
            </StyledTableCell>
            <StyledTableCell colSpan={3} align="right" bgcolor={'#a5dfb7'} fontcolor={"#555555"}>
                <OffsetInputField setNetEmissions_output={setNetEmissions_output} />
            </StyledTableCell>
        </TableRow>
        <TableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <StyledTableCell component="th" scope="row" bgcolor={'#42b868'} >Net Event Carbon Emissions</StyledTableCell>
            <StyledTableCell colSpan={3} align="right" bgcolor={'#42b868'}>{netEmissions_output}</StyledTableCell>
        </TableRow>
        </>
    )
}

const ModTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: '0.8em',
    },
}));
const StyledTableCell = styled(ModTableCell)(({ bgcolor, fontcolor, theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        backgroundColor: 'bgcolor',
        color: fontcolor ? fontcolor : bgcolor ? theme.palette.common.white : theme.palette.common.black,
        fontWeight: 700,
    },
}));